import './index.css'
import App from './App.tsx'
import { mountClient } from '@gjl/site-kit'
import { initOutboundClickTracking } from './lib/analytics'

// Client-only: attaches a document click listener. main.tsx is the browser
// entry (entry-server.tsx never imports it), but guard anyway for safety.
if (typeof window !== 'undefined') {
  initOutboundClickTracking()
}

// Prerendered HTML -> hydrate; empty root (dev) -> fresh render. mountClient
// wraps StrictMode + BrowserRouter and picks hydrate vs render automatically.
mountClient(App)
